import request from '../helpers/request'

const baseUrl = 'https://webwork.kt.ua/serials/api/'
const serialsInfo = baseUrl + 'SerialsForSite/'
const transactionsForSite = baseUrl + 'TransactionsForSite/'
const transactionVerApiUrl = baseUrl + 'TransactionVerification/'
// const smsApiUrl = baseUrl + 'SMS/'
// const itemsApiUrl = baseUrl + 'Items/'
const firmsEndpoint = baseUrl + 'Firms/'
// const transByPhoneEndPoint = baseUrl + 'Transactions/'
// const verifyTransByPhone = baseUrl + 'TransactionVerification/'
// const notificationEndPoint = baseUrl + 'WebLoadedPage'

export default {
  getFirms: async () => {
    const { data } = await request.get(firmsEndpoint)

    return data
  },
  getSerialInfo: async (serial) => {
    const { data } = await request.get(serialsInfo + serial)

    return data
  },
  getSerialFullInfo: async (serial) => {
    const { data } = await request.get(transactionsForSite + serial)

    return data
  },
  postValidFormData: async (formData) => {
    const { data } = await request.post(transactionsForSite, formData)

    return data
  },
  postUnknownFormData: async (formData) => {
    const { data } = await request.post(transactionVerApiUrl, formData)

    return data
  }
}
